<template>
  <div class="couponContainer">
    <div id="checkout">
      <!-- Checkout will insert the payment form here -->
    </div>
  </div>
</template>

<script>
import api from '.././plugins/api'
import { getStripeObject } from '../plugins/stripe'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      price_id: null,
      paywall_id: null,
      partner_id: null,
      email: null,
      user_id: null,
      next_url: null,
      checksum_code: null
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  async mounted() {
    this.price_id = this.$route.query.price_id
    this.paywall_id = this.$route.query.paywall_id
    this.partner_id = this.$route.query.partner_id
    this.email = this.$route.query.email
    this.user_id = this.$route.query.user_id
    this.next_url = this.$route.query.next_url
    this.checksum_code = Number(this.$route.query.checksum_code)
    if (!this.price_id || !this.email) this.$router.push('/')
    await this.initialize()
  },
  methods: {
    initialize: async function() {
      try {
        this.stripe = await getStripeObject()

        const sessionUrl = `${process.env.VUE_APP_BACKEND_URL}/user/stripe/session`
        const sessionResponse = await api.post(
          sessionUrl,
          {
            price_id: this.price_id,
            email: this.email,
            user_id: this.user_id,
            checksum_code: this.checksum_code ? this.checksum_code : null,
            return_url: `${process.env.VUE_APP_FRONTEND_URL}/checkoutCompleted?&price_id=${this.price_id}&paywall_id=${this.paywall_id}&partner_id=${this.partner_id}&session_id={CHECKOUT_SESSION_ID}&next_url=${this.next_url}`,
            metadata: {
              lang: this.$i18n.locale,
              paywallId: this.paywall_id,
              partnerId: this.partner_id
            }
          },
          { headers: { Authorization: process.env.VUE_APP_CONTROL_KEY } }
        )
        const checkout = await this.stripe.initEmbeddedCheckout({
          clientSecret: sessionResponse.data.session_secret
        })

        // Mount Checkout
        checkout.mount('#checkout')
      } catch (error) {
        console.log(error)
        this.$router.push('/')
      }
    }
  }
}
</script>
<style lang="scss">
.couponContainer {
  .subheaderTextCoupon {
    grid-row: 3;
    grid-column: 2/12;
    font-size: 0.8765em;
    color: var(--formColor);
    text-align: left;
  }
  .registerButton {
    grid-row: 1;
    grid-column: 2/12;
    padding: 10px 0px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .buttonCaption {
    grid-row: 1;
    grid-column: 4/13;
    display: flex;
    font-size: 1.1875em;
  }

  .stButtonCaption {
    grid-row: 1;
    grid-column: 1/13;
    font-size: 1.1875em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .formElement {
    grid-column: 2/12;
  }

  .formInputLabel {
    display: flex;
    font-size: 1em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }
  @media screen and (min-width: 620px) {
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
